export const identity = (...args: any[]) => args[0];
